// Show only documented, user-facing platform errors, never raw server traces.
export async function knowledgeApiError(response, fallback) {
  let detail;
  try { detail = (await response.json())?.detail; } catch { /* non-JSON gateway error */ }
  const allowed = new Set(['PLAN_UNAVAILABLE', 'LIMIT_REACHED', 'WORKER_UNAVAILABLE',
    'INVALID_ARGUMENT', 'VERSION_CONFLICT', 'OPERATION_IN_PROGRESS', 'PROVIDER_UNAVAILABLE']);
  const message = allowed.has(detail?.code) && typeof detail.message === 'string'
    ? detail.message.slice(0, 500) : fallback;
  const error = new Error(message);
  error.status = response.status;
  error.code = allowed.has(detail?.code) ? detail.code : null;
  return error;
}
